// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { inverseBackground } from '../../tokens/themeColors/inverse';
export var progressBarColors = function(mode) {
    var bg = background(mode);
    var inverseBg = inverseBackground(mode);
    return {
        default: {
            background: bg.state.disabled1,
            fill: bg.accent
        },
        error: {
            background: bg.state.disabled1,
            fill: bg.status.errorBold4
        },
        gray: {
            background: bg.state.disabled1,
            fill: inverseBg.action
        },
        success: {
            fill: bg.status.successBold
        }
    };
};

//# sourceMappingURL=progressBarColors.js.map